import React from 'react'
import {useMergeRefs} from '@floating-ui/react'
import {usePopoverContext} from './PopoverContext'

const PopoverTrigger = ({children}) => {
    const {refs, getReferenceProps} = usePopoverContext()

    const childRef = children.ref ?? null
    const mergedRef = useMergeRefs([refs.setReference, childRef])

    return React.cloneElement(children, {
        ref: mergedRef,
        ...getReferenceProps(),
    })
}

export default PopoverTrigger
